export const getHeadingDropdownOption = t => [{
  id: 'h1',
  value: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.option.h1')
}, {
  id: 'h2',
  value: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.option.h2')
}, {
  id: 'h3',
  value: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.option.h3')
}, {
  id: 'h4',
  value: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.option.h4')
}, {
  id: 'h5',
  value: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.option.h5')
}, {
  id: 'h6',
  value: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.option.h6')
}, {
  id: 'p',
  value: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.option.p')
}];
//# sourceMappingURL=heading-dropdown-option.js.map